import { useBreakpoint } from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

import type { ProductSamplingItemProps } from './ProductSamplingItem/ProductSamplingItem';
import ProductSamplingItem from './ProductSamplingItem/ProductSamplingItem';

export interface ProductSamplingListProps {
  'data-testid'?: string;
  samples: Array<ProductSamplingItemProps>;
}

const ProductSamplingList: React.FC<ProductSamplingListProps> = ({
  'data-testid': dataTestId = 'paris-product-extra',
  samples
}) => {
  const { isMobile } = useBreakpoint();
  return (
    <div data-testid={dataTestId} className="co-flex co-justify-between">
      <div
        className={classNames('co-flex co-gap-1 ', {
          'co-flex-col': !isMobile
        })}
      >
        {samples?.map((sample) => (
          <ProductSamplingItem {...sample}></ProductSamplingItem>
        ))}
      </div>
    </div>
  );
};
export default ProductSamplingList;
